<template>
  <div>
    <h3>The {{ contentItem.items.length }} {{ contentItem.context.framework }} are:</h3>

    <ul>
      <li
        v-for="(category, cIdx) in contentItem.items"
        :key="cIdx"
      >
        <img
          :src="category.icon"
          :class="{ 'border': !category.icon }"
          :style="{ backgroundColor: category.backgroundColor }"
        >

        <div class="text-container">
          <h3>{{ category.name }}</h3>

          <div v-html="domPurify.sanitize(category.writeUp)" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { useDomPurify } from '@/composables';

const domPurify = useDomPurify();

const props = defineProps({
  contentItem: {
    type: Object,
    required: true,
  },
});
</script>
